import { render, staticRenderFns } from "./show.vue?vue&type=template&id=0f578f1c&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f578f1c')) {
      api.createRecord('0f578f1c', component.options)
    } else {
      api.reload('0f578f1c', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=0f578f1c&", function () {
      api.rerender('0f578f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/captain_working_summaries/show.vue"
export default component.exports